const loading = {
    namespaced: true,
    mutations: {
        mostrar(state, payload) {
            if (typeof(payload)==="string") {
                payload={titulo: payload}
            }
            state.texto=payload.titulo
        },
        ocultar(state) {
            
        }
    },
    actions: {
        mostrar(state, payload) {
            this.commit('loading/mostrar', payload)
        },
        ocultar() {
            this.commit('loading/ocultar')
        }
    }
}

export default loading